/**
 * Web Entry Point
 * React Native Web bootstrapper
 */

import { AppRegistry } from 'react-native';
import App from './App.web';
import { name as appName } from './app.json';

// Disable service workers in development
if (process.env.NODE_ENV === 'development') {
  if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(registration => {
        registration.unregister();
        console.log('Service worker unregistered for development');
      });
    });
  }
}

// Register the app
AppRegistry.registerComponent(appName, () => App);

// Mount the app
const rootTag = document.getElementById('root');
if (rootTag) {
  AppRegistry.runApplication(appName, { 
    rootTag,
    initialProps: {},
  });
  
  // Remove loading screen after app mounts
  setTimeout(() => {
    const loading = document.getElementById('loading-screen');
    if (loading) {
      loading.style.opacity = '0';
      setTimeout(() => loading.remove(), 300);
    }
  }, 100);
} else {
  console.error('Root element not found! App cannot mount.');
}

